import { isAxiosError } from 'axios';

// Prefer the backend's { message } body (e.g. on 403) over axios's generic
// "Request failed with status code N".
export function errorDetail(err: unknown): string {
  if (isAxiosError(err)) {
    const data = err.response?.data as { message?: string } | undefined;
    return data?.message ?? err.message;
  }
  return err instanceof Error ? err.message : 'Unexpected error';
}
